module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-24/noise-f2745099b495bd02f5aa4882b9474faa.svg";